<template>
    <div>
        <b>{{ Title }}:</b>
        <span 
            class="float-right"
            v-b-tooltip.hover
            :title="$t('Webportal.CX.Margin.HealingsLeft', {PLACEHOLDER: AvailableHealings})">
            {{ AvailableHealings }}
            <i class="far fa-medkit"></i>
        </span>
    </div>
</template>

<script>
export default {
    props: {
        Title: String,
        AvailableHealings: Number
    }
}
</script>
